import {
  Currency,
  type CurrencyConstructor,
} from '@webapp/core/entities/external/Currency'
import {
  type MileageRatePresetUnitEnum,
  MileageRatePresetUnits,
} from '@webapp/modules/expense/entities/enums'

export interface MileageRatePresetTax {
  id: number
  name: string
  percentage: string
  isDefault: boolean
  isActive: boolean
  isInclusive: boolean
}

export interface MileageRatePresetConstructor {
  id: number
  name: string
  rate: number
  currency: CurrencyConstructor
  unit: MileageRatePresetUnitEnum
  advisoryFuelRate: Nullable<number>
  tax: Nullable<MileageRatePresetTax>
}

export class MileageRatePreset {
  readonly id: number
  readonly name: string
  readonly rate: number
  readonly currency: Currency
  readonly unit: MileageRatePresetUnitEnum
  readonly advisoryFuelRate: Nullable<number>
  readonly tax: Nullable<MileageRatePresetTax>

  constructor(data: MileageRatePresetConstructor) {
    this.id = data.id
    this.name = data.name
    this.rate = data.rate
    this.currency = new Currency(data.currency)
    this.unit = data.unit
    this.advisoryFuelRate = data.advisoryFuelRate
    this.tax = data.tax
  }

  get displayLabel(): string {
    const unitShort = this.unit === MileageRatePresetUnits.MILES ? 'mi' : 'km'
    return `${this.name} (${this.rate} ${this.currency.name}/${unitShort})`
  }
}
